<template>
  <div>
    <CertificationsMovements
      :certificateId="movementsDialog.certificateId"
      :visible.sync="movementsDialog.visible"
      :customerCode="movementsDialog.customerCode"
    />
    <cardcountRequest
      :myRequestNewCount="newCount"
      :myRequestInProgressCount="progressCount"
      :myRequestInClosedCount="closedCount"
      :myRequestCancellCount="canceledCount"
      :myRequestCompletedCount="completedCount"
      :myRequestAllCount="allCount"
    ></cardcountRequest>

    <div class="mb-20 flex" style="justify-content: flex-end">
      <button class="certifications-blue-btn" @click="openNewDialog">
        Nueva
      </button>
    </div>

    <el-row>
      <el-col>
        <el-card>
          <el-row>
            <el-col>
              <el-tabs
                v-model="activeTab"
                :before-leave="handleTabClick"
                @tab-click="OnTabClick"
              >
                <el-tab-pane label="Nuevas" name="new">
                  <rabbey-table3
                    border
                    ref="new"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />

                  <!-- Dialogo para cambiar fase -->
                  <el-dialog
                    width="30%"
                    :title="dialogPhase.title"
                    :visible.sync="dialogPhase.visible"
                    :before-close="handleCloseDialogPhase"
                  >
                    <el-form
                      ref="formPhase"
                      :model="dialogPhase"
                      :rules="rulesPhase"
                    >
                      <el-form-item prop="faseId">
                        <el-select
                          v-model="dialogPhase.faseId"
                          placeholder="Seleccionar fase"
                          filterable
                          style="width: 100%"
                        >
                          <el-option
                            v-for="(fase, index) in phasesList"
                            :key="index"
                            :value="fase.value"
                            :label="fase.label"
                          />
                        </el-select>
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="handleCloseDialogPhase(() => {})"
                        >Cancelar</el-button
                      >
                      <el-button type="primary" @click="submitChangePhase"
                        >Confirmar</el-button
                      >
                    </span>
                  </el-dialog>
                </el-tab-pane>

                <el-tab-pane label="En Progreso" name="progress">
                  <rabbey-table3
                    border
                    ref="progress"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="Por Calificar" name="closed">
                  <rabbey-table3
                    border
                    ref="closed"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="Completadas" name="completed">
                  <rabbey-table3
                    border
                    ref="completed"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="Todas" name="all">
                  <rabbey-table3
                    border
                    ref="all"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>

                <el-tab-pane label="Canceladas" name="canceled">
                  <rabbey-table3
                    border
                    ref="canceled"
                    v-loading="loading"
                    :data="items"
                    :columns="progressColumns"
                    :actions="actions[activeTab]"
                    :row-class-name="tableRowClassName"
                    :class-table="{
                      'table-box': true,
                      'card-base': true,
                      'card-shadow--medium': false
                    }"
                    paginateFromApi
                    @rtable-push-action="handlePushAction"
                    @update-page-size="updatePageSize"
                    @update-current-page="updateCurrentPage"
                  />
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      width="30%"
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :before-close="handleCloseDialog"
    >
      <el-form ref="form" :model="dialog" :rules="rules[dialog.type]">
        <el-form-item v-if="dialog.type === 'set'" prop="responsableId">
          <el-select
            v-model="dialog.responsableId"
            placeholder="Seleccion personal a asignar"
            filterable
            style="width: 100%"
            @change="onSelectEmployee"
          >
            <el-option
              v-for="(resp, index) in employeList"
              :key="index"
              :value="resp.value"
              :label="resp.label"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog(() => {})">Cancelar</el-button>
        <el-button type="primary" @click="submitChangeResponsible"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>

    <!-- Dialogo para cambiar fase -->
    <el-dialog
      width="30%"
      :title="dialogPhase.title"
      :visible.sync="dialogPhase.visible"
      :before-close="handleCloseDialogPhase"
    >
      <el-form ref="formPhase" :model="dialogPhase" :rules="rulesPhase">
        <el-form-item prop="faseId">
          <el-select
            v-model="dialogPhase.faseId"
            placeholder="Seleccionar fase"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="(fase, index) in phasesList"
              :key="index"
              :value="fase.value"
              :label="fase.label"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialogPhase(() => {})"
          >Cancelar</el-button
        >
        <el-button type="primary" @click="submitChangePhase"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>

    <!-- Diálogo para crear nuevo proceso -->
    <el-dialog
      width="30%"
      title="Nueva Certificación"
      :visible.sync="newDialogVisible"
      :before-close="handleCloseNewDialog"
    >
      <el-form>
        <el-form-item label="Cliente">
          <el-select
            v-model="selectedClient"
            placeholder="Selecciona un cliente"
            filterable
            remote
            :remote-method="searchClients"
            :loading="clientSearchLoading"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="client in newProcessClientList"
              :key="client.id"
              :label="client.name"
              :value="client.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Responsable">
          <el-select
            filterable
            v-model="selectedEmployee"
            placeholder="Selecciona un responsable"
            style="width: 100%"
          >
            <el-option
              v-for="(employee, index) in employeList"
              :key="index"
              :label="employee.label"
              :value="employee.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Tipo Proceso">
          <el-select
            v-model="selectedProcessType"
            placeholder="Selecciona el tipo de proceso"
            style="width: 100%"
          >
            <el-option label="Certificación" value="certificacion" />
            <el-option label="Web Service" value="webservice" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseNewDialog">Cancelar</el-button>
        <el-button type="primary" @click="confirmNewDialog"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import cardcountRequest from "@/components/requests/internal/Cards.vue";
import CertificationsMovements from "./CertificationsMovements.vue";

export default {
  name: "CertificationsCard",
  components: {
    cardcountRequest,
    RabbeyTable3,
    CertificationsMovements
  },
  data() {
    return {
      loading: false,
      activeTab: "new",
      // Dialogo para cambiar fase
      dialogPhase: {
        visible: false,
        title: "",
        faseId: null,
        certificationId: null,
        selectedRow: null
      },
      // Dialogo para movimientos
      movementsDialog: {
        visible: false,
        certificateId: null,
        customerName: ""
      },
      // Lista de fases por defecto
      phasesList: [
        { value: 0, label: "Pendiente" },
        { value: 1, label: "Registro" },
        { value: 2, label: "Pruebas de Datos e-CF" },
        { value: 3, label: "Pruebas de Datos de Aprobacion Comercial" },
        { value: 4, label: "Pruebas Simulacion E-CF" },
        { value: 5, label: "Pruebas Simulacion Presentacion Impresa" },
        { value: 6, label: "Validacion Presentacion Impresa" },
        { value: 7, label: "Url Servicio de Prueba" },
        { value: 8, label: "Inicios Pruebas e-CF" },
        { value: 9, label: "Recepcion e-CF" },
        { value: 10, label: "Inicio Prueba Recepcion Aprobacion Comercial" },
        { value: 11, label: "Recepcion Aprobacion Comercial" },
        { value: 12, label: "Url Servicio Produccion" },
        { value: 13, label: "Declaracion Jurada" },
        { value: 14, label: "Verificacion Estatus" },
        { value: 15, label: "Finalizado" },
        { value: 16, label: "Integracion Web Services" },
        { value: 17, label: "Prueba Integracion" },
        { value: 18, label: "Instalacion en Terminal" }
      ],

      // Contadores genéricos
      newCount: 0,
      progressCount: 0,
      closedCount: 0,
      canceledCount: 0,
      completedCount: 0,
      allCount: 0,

      // Datos de la tabla
      items: [],
      allData: [], // Guardamos todos los datos originales (raw)
      allDataMapped: [], // Datos mapeados a la forma que espera la tabla
      totalItems: 0, // Total de registros traídos desde la API

      // Columnas de la tabla (mostrar: id, cliente, status, responsable)
      progressColumns: [
        {
          prop: "id",
          label: "ID",
          width: 80
        },
        {
          prop: "cliente",
          label: "Cliente",
          width: 400
        },
        {
          prop: "status",
          label: "Fase",
          width: 800
        },
        {
          prop: "responsable",
          label: "Responsable",
          width: 250
        }
      ],

      // Acciones por pestaña
      actions: {
        new: [
          // {
          //   icon: "el-icon-view",
          //   label: "Ver movimientos",
          //   command: "viewMovements"
          // },
          {
            icon: "el-icon-user",
            label: "Cambiar responsable",
            command: "changeResponsible"
          },
          {
            icon: "el-icon-sort",
            label: "Cambiar fase",
            command: "changePhase"
          },
          // {
          //   icon: "el-icon-success",
          //   label: "Marcar como completada",
          //   command: "markCompleted"
          // },
          {
            icon: "el-icon-close",
            label: "Cancelar",
            command: "cancel"
          }
        ],
        progress: [
          {
            icon: "el-icon-view",
            label: "Ver movimientos",
            command: "viewMovements"
          },
          {
            icon: "el-icon-user",
            label: "Cambiar responsable",
            command: "changeResponsible"
          },
          {
            icon: "el-icon-sort",
            label: "Cambiar fase",
            command: "changePhase"
          },
          {
            icon: "el-icon-success",
            label: "Marcar como completada",
            command: "markCompleted"
          },
          { icon: "el-icon-close", label: "Cancelar", command: "cancel" }
        ],
        closed: [
          {
            icon: "el-icon-view",
            label: "Ver movimientos",
            command: "viewMovements"
          },
          // {
          //   icon: "el-icon-user",
          //   label: "Cambiar responsable",
          //   command: "changeResponsible"
          // },
          // {
          //   icon: "el-icon-sort",
          //   label: "Cambiar fase",
          //   command: "changePhase"
          // },
          // {
          //   icon: "el-icon-success",
          //   label: "Marcar como completada",
          //   command: "markCompleted"
          // },
          {
            icon: "el-icon-close",
            label: "Cancelar",
            command: "cancel"
          }
        ],
        completed: [
          {
            icon: "el-icon-view",
            label: "Ver movimientos",
            command: "viewMovements"
          }
          // {
          //   icon: "el-icon-user",
          //   label: "Cambiar responsable",
          //   command: "changeResponsible"
          // },
          // { icon: "el-icon-close", label: "Cancelar", command: "cancel" }
        ],
        all: [
          {
            icon: "el-icon-view",
            label: "Ver movimientos",
            command: "viewMovements"
          }
          // {
          //   icon: "el-icon-user",
          //   label: "Cambiar responsable",
          //   command: "changeResponsible"
          // },
          // {
          //   icon: "el-icon-sort",
          //   label: "Cambiar fase",
          //   command: "changePhase"
          // },
          // {
          //   icon: "el-icon-success",
          //   label: "Marcar como completada",
          //   command: "markCompleted"
          // },
          // { icon: "el-icon-close", label: "Cancelar", command: "cancel" }
        ],
        canceled: [
          {
            icon: "el-icon-view",
            label: "Ver movimientos",
            command: "viewMovements"
          }
        ]
      },

      // Paginación
      currentPage: 1,
      pageSize: 10,
      // Lista de empleados para seleccionar responsable
      employeList: [],

      // Dialog / form para cambiar responsable
      dialog: {
        visible: false,
        title: "",
        type: "",
        responsableId: null,
        selectedRow: null
      },
      // Nombre legible del responsable seleccionado (se captura en onSelectEmployee)
      // para mostrar inmediatamente en la tabla sin esperar otra llamada
      responsableLabel: null,

      // Reglas para el formulario del dialog
      rules: {
        set: {
          responsableId: [
            {
              required: true,
              message: "Seleccione un responsable",
              trigger: "change"
            }
          ]
        }
      },
      // Reglas para el dialogo de fase
      rulesPhase: {
        faseId: [
          { required: true, message: "Seleccione una fase", trigger: "change" }
        ]
      },
      // Diálogo para crear nuevo proceso
      newDialogVisible: false,
      selectedClient: "",
      selectedEmployee: "",
      selectedProcessType: "",
      clientList: [],
      newProcessClientList: [],
      // remote search state
      clientSearchLoading: false,
      clientSearchTimeout: null
    };
  },
  methods: {
    viewMovements(row) {
      const certificateId = row.id || (row.raw && row.raw.Id);
      const customerCode = row.CustomerCode || row.customerCode || "";
      this.movementsDialog.certificateId = certificateId;
      this.movementsDialog.customerCode = customerCode;
      this.movementsDialog.visible = true;
    },
    markCompleted(row) {
      const certificationId = row.id || (row.raw && row.raw.Id);
      if (!certificationId) return;
      const url = `/api/certificationsdgii/ChangeStatus?certificationId=${certificationId}&statusId=3`;
      this.loading = true;
      this.$http
        .put(url)
        .then(() => {
          this.getCertifications();
          this.$message &&
            this.$message.success &&
            this.$message.success("Certificación marcada como completada");
        })
        .catch((error) => {
          console.error("Error al marcar como completada:", error);
          this.$message &&
            this.$message.error &&
            this.$message.error("Error al marcar como completada");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    cancelCertification(row) {
      const certificationId = row.id || (row.raw && row.raw.Id);
      if (!certificationId) return;
      const url = `/api/certificationsdgii/ChangeStatus?certificationId=${certificationId}&statusId=4`;
      this.loading = true;
      this.$http
        .put(url)
        .then(() => {
          // Actualizar localmente el estado de la certificación cancelada por Status
          let idx = this.allDataMapped.findIndex(
            (it) => it.id === certificationId
          );
          if (idx !== -1) {
            this.allDataMapped[idx].raw.Status = "Cancelada";
            this.allDataMapped[idx].status = "Cancelada";
            this.allDataMapped[idx].statusCategory = "canceled";
          }
          if (row) {
            row.raw.Status = "Cancelada";
            row.status = "Cancelada";
            row.statusCategory = "canceled";
          }
          this.processCertificationsData();
          this.filterDataByTab();
          this.$message &&
            this.$message.success &&
            this.$message.success("Certificación cancelada correctamente");
        })
        .catch((error) => {
          console.error("Error al cancelar certificación:", error);
          this.$message &&
            this.$message.error &&
            this.$message.error("Error al cancelar certificación");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleTabClick() {
      // Hook antes de cambiar tab
      return true;
    },
    OnTabClick() {
      // Se ejecuta al hacer click en un tab
      this.filterDataByTab();
    },
    handlePushAction(action) {
      // Maneja las acciones de la tabla

      const { command, row } = action;

      switch (command) {
        case "viewMovements":
          this.viewMovements(row);
          break;
        case "changeResponsible":
          this.changeResponsible(row);
          break;
        case "changePhase":
          this.openChangePhaseDialog(row);
          break;
        case "markCompleted":
          this.markCompleted(row);
          break;
        case "cancel":
          this.cancelCertification(row);
          break;
        default:
          console.warn("Acción desconocida:", command);
      }
    },

    // Abre el dialogo para cambiar fase
    openChangePhaseDialog(row) {
      // Reset dialogo antes de abrir
      this.dialogPhase.title = "Cambiar fase";
      this.dialogPhase.visible = false;
      this.dialogPhase.faseId = null;
      this.dialogPhase.certificationId = row.id || (row.raw && row.raw.Id);
      this.dialogPhase.selectedRow = row;
      this.$nextTick(() => {
        this.dialogPhase.visible = true;
      });
    },

    // Cierra el dialogo de fase
    handleCloseDialogPhase(done) {
      if (typeof done === "function") {
        this.resetDialogPhase();
        done();
      } else {
        this.dialogPhase.visible = false;
        this.resetDialogPhase();
      }
    },

    // Reset dialogo de fase
    resetDialogPhase() {
      this.dialogPhase = {
        visible: false,
        title: "",
        faseId: null,
        certificationId: null,
        selectedRow: null
      };
      if (this.$refs.formPhase && this.$refs.formPhase.resetFields) {
        try {
          this.$refs.formPhase.resetFields();
        } catch (err) {
          // Ignorar errores al resetear el formulario
        }
      }
    },

    // Enviar el cambio de fase al servidor
    submitChangePhase() {
      if (!this.$refs.formPhase) return;
      this.$refs.formPhase.validate((valid) => {
        if (!valid) return;
        const certificationId = this.dialogPhase.certificationId;
        const faseId = this.dialogPhase.faseId;
        // Buscar el estado actual antes de cambiar
        let idx = this.allDataMapped.findIndex(
          (it) => it.id === certificationId
        );
        const prevStatusLabel =
          idx !== -1 ? this.allDataMapped[idx].status : null;
        const url = `/api/certificationsdgii/ChangeFaseCertification?certificationId=${certificationId}&faseId=${faseId}`;
        this.loading = true;
        this.$http
          .put(url)
          .then(() => {
            // Si el estado anterior era "Pendiente", hacer la llamada extra
            if (
              prevStatusLabel &&
              prevStatusLabel.toLowerCase() === "pendiente"
            ) {
              const statusUrl = `/api/certificationsdgii/ChangeStatus?certificationId=${certificationId}&statusId=1`;
              this.$http
                .put(statusUrl)
                .then(() => {
                  this.getCertifications(); // Refrescar datos después de actualizar status
                })
                .catch((err) => {
                  console.error("Error actualizando status a 1:", err);
                });
            }
            // Actualizar localmente la fase en la tabla
            const faseLabel =
              (
                this.phasesList.find(
                  (f) => String(f.value) === String(faseId)
                ) || {}
              ).label || faseId;
            if (idx !== -1) {
              this.allDataMapped[idx].status = faseLabel;
              this.allDataMapped[idx].raw.FaseCertifications = faseLabel;
              this.allDataMapped[idx].raw.faseCertifications = faseLabel;
            }
            if (this.dialogPhase.selectedRow) {
              this.dialogPhase.selectedRow.status = faseLabel;
              if (this.dialogPhase.selectedRow.raw) {
                this.dialogPhase.selectedRow.raw.FaseCertifications = faseLabel;
                this.dialogPhase.selectedRow.raw.faseCertifications = faseLabel;
              }
            }
            this.filterDataByTab();
            this.loading = false;
            this.dialogPhase.visible = false;
            this.resetDialogPhase();
            this.$message &&
              this.$message.success &&
              this.$message.success("Fase actualizada");
          })
          .catch((error) => {
            console.error("Error al cambiar fase:", error);
            this.loading = false;
            this.$message &&
              this.$message.error &&
              this.$message.error("Error al cambiar fase");
          });
      });
    },
    // Abre el dialog para cambiar responsable
    changeResponsible(row) {
      this.dialog.type = "set";
      this.dialog.title = "Cambiar responsable";
      this.dialog.visible = true;
      this.dialog.responsableId = row.responsableId || null;
      this.dialog.selectedRow = row;
      // Cargar lista de empleados para el select
      this.getEmployeesList();
      // Pre-fill the visible name if we can
      const found = (this.employeList || []).find(
        (e) => String(e.value) === String(this.dialog.responsableId)
      );
      this.responsableLabel = found ? found.label : null;
    },

    // Obtiene lista de empleados (opciones para el select)
    getEmployeesList() {
      // If already loaded, keep it
      if (this.employeList && this.employeList.length)
        return Promise.resolve(this.employeList);
      return this.$http
        .get("/api/Employees/GetByCompany?companyID=TB")
        .then((response) => {
          const raw = response.data || [];
          const list = Array.isArray(raw) ? raw : raw.items || [];
          this.employeList = list.map((e) => ({
            value: e.Id ?? e.id ?? e.UserId ?? e.userId ?? e.UserID,
            label:
              e.Name || e.name
                ? (e.Name || e.name) +
                  (e.LastName || e.lastName
                    ? " " + (e.LastName || e.lastName)
                    : "")
                : e.DisplayName ||
                  e.displayName ||
                  e.UserName ||
                  e.userName ||
                  e.Email ||
                  e.email ||
                  ""
          }));

          return this.employeList;
        })
        .catch((error) => {
          console.error("Error al obtener empleados:", error);
          this.employeList = [];
          return this.employeList;
        });
    },

    // Maneja el cierre del dialog
    handleCloseDialog(done) {
      // `done` puede venir desde el slot o ser una función vacía
      if (typeof done === "function") {
        this.resetDialog();
        done();
      } else {
        this.dialog.visible = false;
        this.resetDialog();
      }
    },

    // Captura el cambio en el select y guarda la etiqueta para mostrar inmediatamente
    onSelectEmployee(value) {
      const found = (this.employeList || []).find(
        (e) => String(e.value) === String(value)
      );
      this.responsableLabel = found ? found.label : value || null;
      // Also update dialog.responsableId to ensure consistency
      this.dialog.responsableId = value;
    },

    // Enviar el cambio de responsable al servidor
    submitChangeResponsible() {
      if (!this.$refs.form) return;
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const certId =
          this.dialog.selectedRow &&
          (this.dialog.selectedRow.id ||
            (this.dialog.selectedRow.raw && this.dialog.selectedRow.raw.Id));
        const payload = {
          certificationId: certId,
          responsableId: this.dialog.responsableId
        };

        // Mostrar inmediatamente el nombre seleccionado (no el id) en la tabla usando la etiqueta capturada

        const immediateName =
          this.responsableLabel ||
          (
            (this.employeList || []).find(
              (e) => String(e.value) === String(this.dialog.responsableId)
            ) || {}
          ).label ||
          this.dialog.responsableId;

        // actualizar localmente para que la UI muestre el nombre inmediatamente
        let idx = this.allDataMapped.findIndex((it) => it.id === certId);

        if (idx !== -1) {
          this.allDataMapped[idx].responsableId = this.dialog.responsableId;
          this.allDataMapped[idx].responsable = immediateName;
          if (this.allDataMapped[idx].raw) {
            this.allDataMapped[idx].raw.CertificatorId =
              this.dialog.responsableId;
            this.allDataMapped[idx].raw.certificatorId =
              this.dialog.responsableId;
          }
        }
        if (this.dialog.selectedRow) {
          this.dialog.selectedRow.responsableId = this.dialog.responsableId;
          this.dialog.selectedRow.responsable = immediateName;
          if (this.dialog.selectedRow.raw) {
            this.dialog.selectedRow.raw.CertificatorId =
              this.dialog.responsableId;
            this.dialog.selectedRow.raw.certificatorId =
              this.dialog.responsableId;
          }
        }
        this.filterDataByTab();

        this.loading = true;
        // Intentamos llamar a la API para actualizar responsable (endpoint solicitado)
        const url = `/api/certificationsdgii/ChangeCertificator?certificationId=${payload.certificationId}&certificatorId=${payload.responsableId}`;
        this.$http
          .put(url)
          .then(() => {
            // No sobrescribimos inmediatamente con otra llamada que pueda devolver datos inconsistentes.
            // Confiamos en el nombre que tenemos en `immediateName` o en `employeList`.
            if (idx !== -1) {
              this.allDataMapped[idx].responsableId = this.dialog.responsableId;
              // also update raw to reflect backend field name if present
              if (this.allDataMapped[idx].raw) {
                this.allDataMapped[idx].raw.CertificatorId =
                  this.dialog.responsableId;
                this.allDataMapped[idx].raw.certificatorId =
                  this.dialog.responsableId;
              }
              this.allDataMapped[idx].responsable = immediateName;
            }
            if (this.dialog.selectedRow) {
              this.dialog.selectedRow.responsableId = this.dialog.responsableId;
              if (this.dialog.selectedRow.raw) {
                this.dialog.selectedRow.raw.CertificatorId =
                  this.dialog.responsableId;
                this.dialog.selectedRow.raw.certificatorId =
                  this.dialog.responsableId;
              }
              this.dialog.selectedRow.responsable = immediateName;
            }
            this.filterDataByTab();
            this.loading = false;
            this.dialog.visible = false;
            this.resetDialog();
            this.$message &&
              this.$message.success &&
              this.$message.success("Responsable actualizado");
          })
          .catch((error) => {
            console.error("Error al cambiar responsable:", error);
            this.loading = false;
            this.$message &&
              this.$message.error &&
              this.$message.error("Error al cambiar responsable");
          });
      });
    },

    // Reset del dialog/form
    resetDialog() {
      // reset dialog keeping the object reference
      this.dialog = {
        visible: false,
        title: "",
        type: "",
        responsableId: null,
        selectedRow: null
      };
      if (this.$refs.form && this.$refs.form.resetFields) {
        try {
          this.$refs.form.resetFields();
        } catch (e) {
          /* ignore */
        }
      }
    },
    handleAction(command, row) {
      // Maneja las opciones del dropdown

      switch (command) {
        case "viewMovements":
          this.viewMovements(row);
          break;
        case "changeResponsible":
          this.changeResponsible(row);
          break;
        case "changePhase":
          this.changePhase(row);
          break;
        case "markCompleted":
          this.markCompleted(row);
          break;
        case "cancel":
          this.cancelCertification(row);
          break;
        default:
          console.warn("Acción desconocida:", command);
      }
    },
    tableRowClassName() {
      // Define clases CSS para las filas
      return "";
    },
    updatePageSize(pageSize) {
      // Actualiza el tamaño de página y recarga los datos
      this.pageSize = pageSize;
      this.getCertifications();
    },
    updateCurrentPage(currentPage) {
      // Actualiza la página actual y recarga los datos
      this.currentPage = currentPage;
      this.getCertifications();
    },
    getCertifications() {
      this.loading = true;
      const url = `/api/certificationsdgii/GetCertificationsList?page=${this.currentPage}&pageSize=${this.pageSize}`;
      this.$http
        .get(url)
        .then((response) => {
          // Si la API devuelve { items, total }, usarlo. Si no, asumir array plano
          if (Array.isArray(response.data)) {
            this.allData = response.data;
            this.totalItems = response.data.length;
          } else {
            this.allData = response.data.items || [];
            this.totalItems = response.data.total || this.allData.length;
          }
          // Mapear a la forma que espera la tabla
          this.allDataMapped = this.allData.map((item) =>
            this.mapToTableItem(item)
          );
          this.processCertificationsData();
          this.filterDataByTab();
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error al obtener certificaciones:", error);
          this.loading = false;
        });
    },
    mapToTableItem(item) {
      // Mapea campos comunes del API a las props que usa la tabla
      const id = item.Id ?? item.id ?? null;
      const cliente =
        item.CustomerName ?? item.customerName ?? item.Cliente ?? "";
      const faseLabel =
        item.FaseCertifications ?? item.faseCertifications ?? item.Fase ?? "";
      const responsableId =
        item.CertificatorId ??
        item.certificatorId ??
        item.responsable ??
        item.responsible ??
        "";

      // Normalizar estado a uno de: new, progress, closed, completed, canceled
      // Priorizar FaseCertifications para mostrar en la columna "Fase/Estado"
      const statusFromApi =
        faseLabel && String(faseLabel).trim() !== ""
          ? faseLabel
          : item.Status ?? item.status ?? "";

      // Normalizar etiqueta de estado (mantener etiqueta en español para mostrar)
      let statusLabel = String(statusFromApi).trim();
      // Asegurar valores esperados (capitalización consistente si vienen códigos numéricos)
      if (/^\s*0\s*$/.test(statusLabel)) statusLabel = "Nueva";
      else if (/^\s*1\s*$/.test(statusLabel)) statusLabel = "En Progreso";
      else if (/^\s*2\s*$/.test(statusLabel)) statusLabel = "Por Calificar";
      else if (/^\s*3\s*$/.test(statusLabel)) statusLabel = "Completada";
      else if (/^\s*4\s*$/.test(statusLabel)) statusLabel = "Cancelada";

      // Determinar categoría interna para filtrar (new, progress, closed, completed, canceled)
      // PRIORIDAD: usar el campo Status del API para clasificación si existe (ej. 'Nueva', 'En Progreso', ...)
      const statusForCategoryRaw = item.Status ?? item.status ?? null;
      const statusForCategory =
        statusForCategoryRaw !== null
          ? String(statusForCategoryRaw).toLowerCase()
          : null;
      let statusCategory = "unknown";
      const decideCategory = (txt) => {
        const s = (txt || "").toLowerCase();
        if (s.includes("nue") || s.includes("pend")) return "new"; // Nueva / Pendiente
        if (s.includes("progres")) return "progress"; // En Progreso
        if (s.includes("por calif") || s.includes("calific")) return "closed"; // Por Calificar
        if (s.includes("completa")) return "completed"; // Completada
        if (s.includes("cancel") || s.includes("anul")) return "canceled"; // Cancelada / Anulada
        return "unknown";
      };

      if (statusForCategory) {
        statusCategory = decideCategory(statusForCategory);
      } else {
        statusCategory = decideCategory(statusLabel);
      }

      return {
        id,
        cliente,
        status: statusLabel,
        statusCategory,
        responsable: responsableId,
        responsableId,
        raw: item // conservar el original por si hace falta
      };
    },
    getUserResponsable(responsableId) {
      if (!responsableId) {
        return Promise.resolve(responsableId);
      }
      return this.$http
        .get("/api/Employees", {
          params: { userId: responsableId }
        })
        .then((response) => {
          return (
            response.data.Name + " " + response.data.LastName || responsableId
          );
        })
        .catch((error) => {
          console.error("Error al obtener usuario:", error);
          return responsableId;
        });
    },
    processCertificationsData() {
      // Contar usando los datos mapeados (Status)
      const data = this.allDataMapped || [];
      this.newCount = data.filter(
        (item) =>
          (item.raw && String(item.raw.Status).toLowerCase().includes("nue")) ||
          String(item.raw.Status).toLowerCase().includes("pend")
      ).length;
      this.progressCount = data.filter(
        (item) =>
          item.raw && String(item.raw.Status).toLowerCase().includes("progres")
      ).length;
      this.closedCount = data.filter(
        (item) =>
          item.raw && String(item.raw.Status).toLowerCase().includes("calific")
      ).length;
      this.completedCount = data.filter(
        (item) =>
          item.raw && String(item.raw.Status).toLowerCase().includes("completa")
      ).length;
      this.canceledCount = data.filter(
        (item) =>
          (item.raw &&
            String(item.raw.Status).toLowerCase().includes("cancel")) ||
          String(item.raw.Status).toLowerCase().includes("anul")
      ).length;
      this.allCount = data.length;

      // Obtener nombres de usuarios certificadores desde la tabla de employees (preferir employeList si está cargada)
      data.forEach((item) => {
        if (item.responsableId) {
          // Preferir buscar en la lista ya cargada para evitar llamadas inconsistentes
          const found = (this.employeList || []).find(
            (e) => String(e.value) === String(item.responsableId)
          );
          if (found) {
            item.responsable = found.label;
          } else {
            // Fallback: pedir al API individualmente
            this.getUserResponsable(item.responsableId).then(
              (responsableName) => {
                if (responsableName) {
                  item.responsable = responsableName;
                }
              }
            );
          }
        }
      });
    },
    filterDataByTab() {
      // Filtrar los datos según la pestaña activa usando Status
      const data = this.allDataMapped || [];
      switch (this.activeTab) {
        case "new":
          this.items = data.filter(
            (item) =>
              item.raw &&
              (String(item.raw.Status).toLowerCase().includes("nue") ||
                String(item.raw.Status).toLowerCase().includes("pend"))
          );
          break;
        case "progress":
          this.items = data.filter(
            (item) =>
              item.raw &&
              String(item.raw.Status).toLowerCase().includes("progres")
          );
          break;
        case "closed":
          this.items = data.filter(
            (item) =>
              item.raw &&
              String(item.raw.Status).toLowerCase().includes("calific")
          );
          break;
        case "completed":
          this.items = data.filter(
            (item) =>
              item.raw &&
              String(item.raw.Status).toLowerCase().includes("completa")
          );
          break;
        case "canceled":
          this.items = data.filter(
            (item) =>
              item.raw &&
              (String(item.raw.Status).toLowerCase().includes("cancel") ||
                String(item.raw.Status).toLowerCase().includes("anul"))
          );
          break;
        case "all":
          this.items = data;
          break;
        default:
          this.items = data;
      }
    },
    // Métodos para el diálogo de nuevo proceso
    openNewDialog() {
      this.newDialogVisible = true;
      this.selectedClient = "";
      this.selectedEmployee = "";
      this.selectedProcessType = "";
      this.fetchClients();
      this.fetchEmployeesForNewProcess();
    },
    handleCloseNewDialog() {
      this.newDialogVisible = false;
    },
    confirmNewDialog() {
      // Validar que todos los campos estén llenos
      if (
        !this.selectedClient ||
        !this.selectedEmployee ||
        !this.selectedProcessType
      ) {
        this.$message &&
          this.$message.warning &&
          this.$message.warning("Por favor completa todos los campos");
        return;
      }

      // Preparar payload para la API
      const payload = {
        CustomerCode: this.selectedClient,
        CertificatorId: this.selectedEmployee,
        TypeProcess: this.selectedProcessType
      };

      this.loading = true;

      // Hacer POST a la API
      this.$http
        .post("/api/certificationsdgii/CreatedNewCertification", payload)
        .then(() => {
          this.newDialogVisible = false;
          // Resetear campos
          this.selectedClient = "";
          this.selectedEmployee = "";
          this.selectedProcessType = "";
          // Recargar lista de certificaciones
          this.getCertifications();
          this.$message &&
            this.$message.success &&
            this.$message.success("Proceso creado correctamente");
        })
        .catch((error) => {
          console.error("Error al crear certificación:", error);
          this.$message &&
            this.$message.error &&
            this.$message.error("Error al crear el proceso");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchClients() {
      this.$store
        .dispatch("customers/getCustomers")
        .then(() => {
          this.newProcessClientList = this.$store.state.customers.list.map(
            (item) => ({
              id: item.ClientCode ?? item.id,
              name: item.Name ?? item.name,
              ...item
            })
          );
        })
        .catch((error) => {
          console.error("Error al obtener clientes:", error);
          this.newProcessClientList = [];
        });
    },
    // Remote search for clients (debounced) using Vuex action
    searchClients(query) {
      if (!query || String(query).trim() === "") {
        // If empty query, clear results (or keep previously loaded full list if you prefer)
        this.newProcessClientList = [];
        return;
      }

      if (this.clientSearchTimeout) clearTimeout(this.clientSearchTimeout);
      this.clientSearchTimeout = setTimeout(() => {
        this.clientSearchLoading = true;
        this.$store
          .dispatch("customers/getCustomerByCriteria", { name: query })
          .then(() => {
            const result = this.$store.state.customers.result || [];
            this.newProcessClientList = result.map((item) => ({
              id: item.ClientCode ?? item.ClientId ?? item.id,
              name:
                item.Name ??
                item.name ??
                item.DisplayName ??
                item.ClientName ??
                "",
              ...item
            }));
          })
          .catch((err) => {
            console.error("Error buscando clientes:", err);
            this.newProcessClientList = [];
          })
          .finally(() => {
            this.clientSearchLoading = false;
          });
      }, 300);
    },
    async fetchEmployeesForNewProcess() {
      try {
        const response = await this.$http.get(
          "/api/Employees/GetByCompany?companyID=TB"
        );
        const raw = response.data || [];
        const list = Array.isArray(raw) ? raw : raw.items || [];
        this.employeList = list.map((e) => ({
          value: e.Id ?? e.id ?? e.UserId ?? e.userId ?? e.UserID,
          label:
            e.Name || e.name
              ? (e.Name || e.name) +
                (e.LastName || e.lastName
                  ? " " + (e.LastName || e.lastName)
                  : "")
              : e.DisplayName ||
                e.displayName ||
                e.UserName ||
                e.userName ||
                e.Email ||
                e.email ||
                ""
        }));
      } catch (error) {
        console.error("Error al obtener empleados:", error);
        this.employeList = [];
      }
    }
  },
  mounted() {
    // Load employees and phases first
    this.getEmployeesList()
      .then(() => {
        this.getCertifications();
      })
      .catch(() => {
        this.getCertifications();
      });
  }
};
</script>

<style scoped>
.certifications-blue-btn {
  background: linear-gradient(90deg, #63aee0 0%, #63aee0 100%);
  color: #fff;
  border: 2px solid #2563eb;
  border-radius: 24px;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.12);
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s, border 0.2s;
}

.certifications-blue-btn:hover {
  background: linear-gradient(90deg, #1e40af 0%, #2563eb 100%);
  border: 2px solid #1e40af;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.18);
}
</style>
